<template>
  <Modal
    :show="isModalOpen"
    container-class="atb-w-96"
    body-class="atb-border-none"
    footer-class="atb-flex atb-flex-row atb-justify-end atb-gap-8"
    @onModalClose="changeModalVisibility"
  >
    <template #header>
      {{ $t('areYouSure') }}
    </template>
    <template #body>
      <span> {{ renderMessage() }} </span>
    </template>
    <template #footer>
      <Button
        motif="basic"
        @click="changeModalVisibility"
      >
        {{ $t('cancel') }}
      </Button>
      <Button @click="deleteRecords">
        {{ $t('delete') }}
      </Button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';
  import { useModal } from '@/app/shared/hooks/use-modal';
  import { useI18n } from 'vue-i18n';
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';

  interface DeleteProps {
    isUsed?: any;
    entity: string;
  }
  interface DeleteEvent {
    (_event: 'delete'): void;
  }
  const props = defineProps<DeleteProps>();
  const emit = defineEmits<DeleteEvent>();
  const { isUsed, entity } = toRefs(props);
  const { isModalOpen, changeModalVisibility } = useModal();
  const { t } = useI18n();

  const renderMessage = () => {
    if (isUsed?.value?.length > 0) {
      return t(`checking${entity.value}DeletionInuse`);
    } else {
      return t(`checking${entity.value}Deletion`);
    }
  };

  const deleteRecords = () => {
    changeModalVisibility();
    emit('delete');
  };

  defineExpose({
    changeModalVisibility,
  });
</script>
